// Currency Types
export interface Currency {
  code: string;
  name: string;
  symbol: string;
  flag?: string;
}

export interface ExchangeRates {
  [currencyCode: string]: number;
}

export interface CurrencyState {
  selectedCurrency: Currency;
  exchangeRates: ExchangeRates;
  baseCurrency: string;
  lastUpdated: Date | null;
  isLoading: boolean;
  error: string | null;
}

export interface CurrencyContextType {
  currencyState: CurrencyState;
  changeCurrency: (currency: Currency) => void;
  convertPrice: (amount: number, fromCurrency?: string) => number;
  formatPrice: (amount: number, fromCurrency?: string) => string;
  refreshRates: () => Promise<void>;
}

// Supported currencies with symbols
export const SUPPORTED_CURRENCIES: Currency[] = [
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
  { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺' },
  { code: 'GBP', name: 'British Pound', symbol: '£', flag: '🇬🇧' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'Dh', flag: '🇦🇪' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', flag: '🇸🇦' },
  // { code: 'JPY', name: 'Japanese Yen', symbol: '¥', flag: '🇯🇵' },
  // { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', flag: '🇨🇳' },
  // { code: 'INR', name: 'Indian Rupee', symbol: '₹', flag: '🇮🇳' },
  // { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', flag: '🇨🇦' },
  // { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: '🇦🇺' },
  // { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr', flag: '🇨🇭' },
  // { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', flag: '🇸🇪' },
  // { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', flag: '🇳🇴' },
  // { code: 'DKK', name: 'Danish Krone', symbol: 'kr', flag: '🇩🇰' },
  // { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', flag: '🇵🇱' },
  // { code: 'TRY', name: 'Turkish Lira', symbol: '₺', flag: '🇹🇷' },
  // { code: 'RUB', name: 'Russian Ruble', symbol: '₽', flag: '🇷🇺' },
  // { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', flag: '🇧🇷' },
  // { code: 'MXN', name: 'Mexican Peso', symbol: '$', flag: '🇲🇽' },
  // { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: '🇿🇦' },
  // { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', flag: '🇸🇬' },
  // { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', flag: '🇭🇰' },
  // { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', flag: '🇳🇿' },
  // { code: 'KRW', name: 'South Korean Won', symbol: '₩', flag: '🇰🇷' },
  // { code: 'THB', name: 'Thai Baht', symbol: '฿', flag: '🇹🇭' },
  // { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', flag: '🇲🇾' },
  // { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', flag: '🇮🇩' },
  // { code: 'PHP', name: 'Philippine Peso', symbol: '₱', flag: '🇵🇭' },
  // { code: 'VND', name: 'Vietnamese Dong', symbol: '₫', flag: '🇻🇳' },
  // { code: 'EGP', name: 'Egyptian Pound', symbol: 'ج.م', flag: '🇪🇬' },
];

// Default currency (AED - UAE Dirham)
export const DEFAULT_CURRENCY: Currency = SUPPORTED_CURRENCIES.find(c => c.code === 'AED') || SUPPORTED_CURRENCIES[0];